import { Box, Table, TableContainer } from "@mui/material";
import EntryProductRow from "./EntryProductRow";
import EntryTableHeaderRow from "./EntryTableHeaderRow";
import { useDetailSelectOptions } from "../../../hooks/useDetailSelectOptions";

function EntryTable({products, control, keyHandler}) {
  
  const selectOptions = useDetailSelectOptions();

  return (
    <Table>
      <TableContainer sx={{maxWidth: "calc(100vw - 100px)", overflowX:"scroll"}}>
        <EntryTableHeaderRow />
        {
          products.map((product, index) => (
            <EntryProductRow
              key={`entity_product_row_${product.productIndex}`}
              product={product}
              control={control}
              selectOptions={selectOptions}
              keyHandler={keyHandler(index)}
            />
          ))
        }
      </TableContainer>
    </Table>
  )
}


export default EntryTable;